import React, { memo } from "react";

// import component
import FormikContainer from "../../components/Formik/FormikContainer";
import DButton from "../../components/DButton";
import FieldContainer from "../../components/Formik/FieldContainer";
import { Form } from "formik";
import DCard from "../../components/DCard";
import { Spinner } from "@chakra-ui/react";

const availableOptions = [
  {
    id: 1,
    title: "اختر",
    value: "",
  },
  {
    id: 2,
    title: "متاح",
    value: 1,
  },
  {
    id: 3,
    title: "غير متاح",
    value: 0,
  },
];

const levelOptions = [
  {
    id: 1,
    title: "اختر",
    value: "",
  },
  {
    id: 2,
    title: "المستوى 1",
    value: "level_one",
  },
  {
    id: 3,
    title: "المستوى 2",
    value: "level_two",
  },
  {
    id: 4,
    title: "المستوى 3",
    value: "level_three",
  },
];
const UserForm = ({
  onSubmit,
  initialValues,
  validationSchema,
  gridStyle,
  btnText,
}) => {
  return (
    <DCard>
      <FormikContainer
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, isSubmitting }) => (
          <Form>
            <div className={`grid  gap-4 ${gridStyle}`}>
              <FieldContainer name="name" type="text" label="الاسم" id="name" />
              <FieldContainer
                name="username"
                type="text"
                label="اسم المستخدم"
                id="username"
              />

              {"is_available" in values && (
                <FieldContainer
                  name="is_available"
                  type="select"
                  label="نوع الحساب"
                  id="is_available"
                  options={availableOptions}
                />
              )}
              {"level" in values && (
                <FieldContainer
                  name="level"
                  type="select"
                  label="مستوى الحساب"
                  id="level"
                  options={levelOptions}
                />
              )}
              <FieldContainer
                name="password"
                type="text"
                label="كلمة المرور"
                id="password"
              />
              <FieldContainer
                name="max_emergency_balance"
                type="text"
                label="الحدالأقصى للدين"
                id="max_emergency_balance"
              />
            </div>
            <DButton
              disabled={isSubmitting}
              type="submit"
              className="mx-auto min-w-[150px] rounded-lg flex items-center justify-center text-white"
            >
              {isSubmitting ? <Spinner /> : btnText}
            </DButton>
          </Form>
        )}
      </FormikContainer>
    </DCard>
  );
};

export default memo(UserForm);
